import React from 'react';
import { Link } from '@ftdr/blueprint-components-react';
import { useNavigate } from 'react-router-dom';
import paths from '@constants/paths';
import REText from '@components/wrappedBDS/REText';

const ServiceUnavailable = () => {
  const navigate = useNavigate();

  function clickLink() {
    navigate(paths.ContactUs);
  }

  return (
    <>
      <REText>
        {'We do not offer home warranties in this zip code. Enter a new zip code or contact our '}
        <Link
          onClick={clickLink}
          color="interactive"
          underline="always"
          className="color-primary-300"
        >
          {'support team'}
        </Link>
        {' for assistance.'}
      </REText>
    </>
  );
};

export default ServiceUnavailable;
